import { createContext, useContext, useState, useCallback, type ReactNode } from "react"

interface Counts {
  dashboard: number
  clients: number
  accounts: number
  mails: number
  users: number
  operators: number
  archive: number
  logs: number
  dumps: number
  profiles: number
  listings: number
  jobs: number
  matching: number
  visits: number
  gmail: number
  activity: number
  statistic?: number
  bot?: number
  // documentation: number
}

interface CountContextValue {
  counts: Counts
  setCount: (key: keyof Counts, value: number) => void
}

const CountContext = createContext<CountContextValue>({
  counts: {
    dashboard: 0,
    clients: 0,
    accounts: 0,
    mails: 0,
    users: 0,
    operators: 0,
    archive: 0,
    logs: 0,
    dumps: 0,
    profiles: 0,
    listings: 0,
    jobs: 0,
    matching: 0,
    visits: 0,
    gmail: 0,
    activity: 0,
    // documentation: 0,
  },
  setCount: () => {},
})

export function CountProvider({ children }: { children: ReactNode }) {
  const [counts, setCounts] = useState<Counts>({
    dashboard: 0,
    clients: 0,
    accounts: 0,
    mails: 0,
    users: 0,
    operators: 0,
    archive: 0,
    logs: 0,
    dumps: 0,
    profiles: 0,
    listings: 0,
    jobs: 0,
    matching: 0,
    visits: 0,
    gmail: 0,
    activity: 0,
    // documentation: 0,
  })

  const setCount = useCallback((key: keyof Counts, value: number) => {
    setCounts((prev) => ({ ...prev, [key]: value }))
  }, [])

  return <CountContext.Provider value={{ counts, setCount }}>{children}</CountContext.Provider>
}

export const useCounts = () => useContext(CountContext)
